import { ApiRequest } from "../shared/types/Types";
import AxiosClient from "./AxiosClient.ts";

export async function apiRequest<TResponse = any, TPayload = any>({
    url,
    method = "GET",
    data,
    params,
    headers,
    raw = false,
}: ApiRequest<TPayload>): Promise<TResponse> {

    const response = await AxiosClient.request<TResponse>({
        url,
        method,
        data,
        params,
        headers,
    });

    return response.data;
}

export const apiClient = {
    get: <TResponse = any>(url: string, params?: Record<string, any>) =>
        apiRequest<TResponse>({
            url,
            method: "GET",
            params,
        }),

    post: <TResponse = any, TPayload = any>(
        url: string,
        data?: TPayload,
        params?: Record<string, any>
    ) =>
        apiRequest<TResponse, TPayload>({
            url,
            method: "POST",
            data,
            params,
        }),

    put: <TResponse = any, TPayload = any>(
        url: string,
        data?: TPayload,
        params?: Record<string, any>
    ) =>
        apiRequest<TResponse, TPayload>({
            url,
            method: "PUT",
            data,
            params,
        }),

    patch: <TResponse = any, TPayload = any>(
        url: string,
        data?: TPayload,
        params?: Record<string, any>
    ) =>
        apiRequest<TResponse, TPayload>({
            url,
            method: "PATCH",
            data,
            params,
        }),

    delete: <TResponse = any>(url: string, params?: Record<string, any>) =>
        apiRequest<TResponse>({
            url,
            method: "DELETE",
            params,
        }),
};